import {Component, OnInit, ViewChild, Input} from '@angular/core';
import {NgForm} from '@angular/forms/forms';
import {DirectoryService} from '../../../services/directory.service';
import {ApiClientService} from '../../../services/api-client.service';
import {Resident} from '../../../types/data.types';
import {AccountPermissionsService} from '../../../services/account-permissions.service';
import {ConstantsService} from '../../../services/constants.service';
import { FrontDeskInstructionsService } from '../../../services/front-desk-instructions.service';
import { UrlService } from '../../../services/url.service';
import { AuthenticationService } from '../../../services/authentication.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'add-instructions-modal',
    templateUrl: './add-instructions-modal.component.html',
    styleUrls: ['./add-instructions-modal.component.scss'],
})

export class AddInstructionsModalComponent implements OnInit {
    @ViewChild('form') form;
    @Input('frontDeskInstructions') frontDeskInstructions?;
    data = new Resident();
    showModal = false;
    disabledSubmit = false;
    showSpinner = false;
    startDate: Date = new Date();
    endDate: Date;
    instructions = '';
    subject = '';
    instructionType: string = '';

    constructor(
        public directoryService: DirectoryService,
        public api: ApiClientService,
        public account: AccountPermissionsService,
        public frontDeskInstructionsService: FrontDeskInstructionsService,
        private urlService: UrlService,
        public authenticationService: AuthenticationService
    ) {}

    ngOnInit() {
        this.instructionType = this.directoryService.instructionsModalType ? this.directoryService.instructionsModalType : 'entry_instruction';
        if (this.directoryService.instructionInInstructionsModal) {
            this.subject = this.directoryService.instructionInInstructionsModal.subject;
            this.instructions = this.directoryService.instructionInInstructionsModal.text;
            this.startDate = this.directoryService.instructionInInstructionsModal.startDate;
            this.endDate = this.directoryService.instructionInInstructionsModal.endDate;
            this.instructionType = this.directoryService.instructionInInstructionsModal.type ? this.directoryService.instructionInInstructionsModal.type : 'entry_instruction';
        }
        setTimeout(() => this.showModal = true, 300);
    }

    onSubmit(form: NgForm): void {

        if (!this.startDate || !this.instructions) {
            toastr.warning('All required fields must be filled.');
            return;
        }

        const data = {
            startDate: moment(this.startDate).format('YYYY-MM-DD') + 'T00:00:00+00:00',
            endDate: this.endDate ? moment(this.endDate).format('YYYY-MM-DD') + 'T23:59:00+00:00' : '',
            subject: this.subject,
            text: this.instructions,
            user: this.directoryService.instructionsModalUser,
            type: this.instructionType
        };
        let url = '';
        const method = !this.directoryService.instructionInInstructionsModal ? 'post' : 'patch';
        if(!this.directoryService.instructionInInstructionsModal)
            url = '/v1/resident_instruction';
        else
            url = `/v1/resident_instruction/${this.directoryService.instructionInInstructionsModal.id}.json`;

        if (!data.user) {
            data.user = JSON.parse(localStorage.getItem('residentselectedBuilding')).residentBdId;
        }
        this.api[method]('domainBD', url, data).subscribe(
            (res) => {
                toastr.success('Instructions have been saved successfully');
                res.startDate = res.startDate.slice(0, -6);
                res.endDate = res.endDate ? res.endDate.slice(0, -6) : '';
                if (moment(res.startDate)._d > moment()._d)
                    res.status = 'future';
                else if (moment(res.endDate)._d < moment()._d)
                    res.status = 'past';
                else if (moment()._d >= moment(res.startDate)._d && moment()._d <= moment(res.endDate)._d)
                    res.status = 'current';
                else if (moment()._d >= moment(res.startDate)._d && !res.endDate)
                    res.status = 'current';

                res.visible = true;
                if(this.directoryService.selectedResidentInstructions.length > 0) {
                    if (!this.directoryService.instructionInInstructionsModal)
                        this.directoryService.selectedResidentInstructions.push(res);
                    else {
                        const index = this.directoryService.selectedResidentInstructions.findIndex(i => i.id == res.id);
                        this.directoryService.selectedResidentInstructions[index] = res;
                    }
                } else
                    this.directoryService.residentInstructionUpdated.emit(res);
                this.form.reset();
                this.hideModal(form);
            }, error => {
                this.api.errorHandler(error, 'Failed to save instructions.');
                this.showSpinner = false;
            }
        );
    }

    onStartDateChange(): void {
        if(new Date(this.startDate) > new Date(this.endDate)) {
            this.endDate = null;
            this.form.value.endDate = null;
        }
    }

    onEndDateChange(event) {
        if (event) {
            this.endDate = new Date(event.getFullYear(), event.getMonth(), event.getDate(), 23, 59);
        }
    }

    hideModal(form) {
        if (!this.frontDeskInstructions) {
            if (form.dirty && form.touched) {
                swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                    () => {
                        this.directoryService.showAddInstructionsModal = false;
                        this.directoryService.instructionsModalType = '';
                        this.directoryService.instructionsModalUser = null;
                        this.directoryService.instructionInInstructionsModal = null;
                    }
                );
            } else
                this.directoryService.showAddInstructionsModal = false;
            this.directoryService.instructionsModalType = '';
            this.directoryService.instructionsModalUser = null;
            this.directoryService.instructionInInstructionsModal = null;
        } else {
            if (form.dirty && form.touched) {
                swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                    () => {
                        this.directoryService.instructionsModalType = '';
                        this.directoryService.instructionsModalUser = null;
                        this.directoryService.instructionInInstructionsModal = null;
                        this.frontDeskInstructionsService.isFrontDeskInstructionsModalShow = false;
                    }
                );
            } else {
                this.directoryService.instructionsModalType = '';
                this.directoryService.instructionsModalUser = null;
                this.directoryService.instructionInInstructionsModal = null;
                this.frontDeskInstructionsService.isFrontDeskInstructionsModalShow = false;
                if (this.urlService.queryParams['tab'] === 'allInstructions') {
                    this.frontDeskInstructionsService.getInstructions();
                }
            }
        }

    }
}




// WEBPACK FOOTER //
// /app/src/app/components/directory/add-instructions-modal/add-instructions-modal.component.ts